import LoginForm from '../../components/Login/LoginForm';
import '../../css/LoginPage.css';

const LoginPage = () => {
  return (
    <div className="login-page">
      <LoginForm />
    </div>
  );
};

export default LoginPage;